import React from 'react';

import Link from 'components/link/Link';

import { ISearchSuggestions } from 'source/NFR.types';

const SearchSuggestions: React.FC<ISearchSuggestions> = ({ label, suggestions }) => (
  <div className="search-suggestions">
    <span className="search-suggestions__label">{label}</span>
    {suggestions?.map((suggestion, index) => (
      <React.Fragment key={`${suggestion}-${index}`}>
        <Link text={suggestion} url={`?q=${suggestion}`} />
        {index < suggestions.length - 1 && <span>,&nbsp;</span>}
      </React.Fragment>
    ))}
  </div>
);

SearchSuggestions.displayName = 'SearchSuggestions';

export default SearchSuggestions;
